// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3tKgc","tab":"ProcedureTabs_tab__3W-BT"};